import { render } from "./PubmedVideo.vue?vue&type=template&id=143f20a7&scoped=true"
import script from "./PubmedVideo.vue?vue&type=script&lang=js"
export * from "./PubmedVideo.vue?vue&type=script&lang=js"

import "./PubmedVideo.vue?vue&type=style&index=0&id=143f20a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143f20a7"]])

export default __exports__